import { render } from "./Edit.vue?vue&type=template&id=d97ce0ca"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/DonationTypes/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d97ce0ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d97ce0ca', __exports__)) {
    console.log('reload')
    api.reload('d97ce0ca', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=d97ce0ca", () => {
    console.log('re-render')
    api.rerender('d97ce0ca', render)
  })

}


export default __exports__